<template>
  <div class="oms-menu" :style="cssVars">
    <div class="oms-menu-header" :style="{ background: logoUi.navigationBackColor}">
      <span v-if="!collapsed">
        <img
          class="logo"
          :src="logoUi.menuSrc[0].src || ''"
          :style="{ margin: '0 10px 0 0', height: menuLogoHeight }"
          alt=""
        />
        <span style="color: white" v-if="!collapsed">{{ logoUi.menuTest || "" }}</span>
      </span>
      <img
        class="logo"
        v-else
        :src="logoUi.menuSrc[1].src || ''"
        :style="{ margin: '10px', height: menuLogoHeight }"
        alt=""
      />
    </div>
    <div class="oms-menu-content" :style="{ background: logoUi.navigationBackColor}">
      <a-menu
      :style="{ background: logoUi.navigationBackColor, width: '100%'}"
        mode="inline"
        theme="dark"
        :inline-collapsed="collapsed"
        :selectedKeys="selectedKey"
        :default-open-keys.sync="openKeys"
        @click="handleClick"
        @openChange="openChange"
      >
        <template v-for="item in menuList">
          <a-sub-menu v-if="item.children && item.children.length" :key="item.menuCode">
            <div slot="title">
              <div style="text-align: center">
                <div class="iconBg" :class="{ collapsedIconBg: !collapsed }">
                  <IconFont v-if="areIcon(item.icon || '')" :type="item.icon" />
                  <a-icon v-else :type="item.icon" />
                  <span>{{ item.menuName }}</span>
                </div>
              </div>
            </div>
            <a-menu-item
              class="ant-menu-item"
              v-for="subItem in item.children"
              :key="subItem.menuCode"
            >
              {{ subItem.menuName }}
            </a-menu-item>
          </a-sub-menu>
          <a-menu-item v-else :key="item.menuCode">
            <IconFont v-if="areIcon(item.icon) || ''" :type="item.icon" />
            <a-icon v-else :type="item.icon" />
            <span>{{ item.menuName }}</span>
          </a-menu-item>
        </template>
      </a-menu>
    </div>
    <div
      @click="menuSwitchOnClick"
      class="menu-switch"
      :class="{ menuUnfold: !collapsed, menuFold: collapsed }"
    >
      <img
        v-if="collapsed"
        class="menu-unfold"
        width="12"
        height="12"
        src="../assets/images/menuOpen@2x.png"
      />
      <img
        v-else
        class="menu-unfold"
        width="12"
        height="12"
        src="../assets/images/menuClose@2x.png"
      />
    </div>
  </div>
</template>

<script>
import { message, Icon } from 'ant-design-vue';
import { post } from '@/utils/http';
import api from '@/api';
import { getLogo } from '@/utils/intConfiguration';
// eslint-disable-next-line import/no-duplicates
import mainBus from '@/micro/eventBus';
import { pointTools, pointMenus } from '@/utils/point';
import PermissionsTranslation from '../utils/permissions';
// eslint-disable-next-line import/extensions
import iconfrontjs from '../assets/iconfont/iconfont.js';

const IconFont = Icon.createFromIconfontCN({
  scriptUrl: iconfrontjs,
});
// eslint-disable-next-line camelcase
export default {
  name: 'OmsMenu',
  components: {
    IconFont,
  },
  data() {
    return {
      logoUi: getLogo(),
      selectedKey: [''],
      openKeys: [''],
      menuList: [],
      collapsed: false,
      openKey: '',
    };
  },
  computed: {
    cssVars() {
      return {
        "--navigationBackColor": this.logoUi.navigationBackColor,
        "--themeColor": this.logoUi.themeColor,
        "--navigationFoldColor": this.logoUi.navigationFoldColor,
      };
    },
    menuLogoHeight() {
      return this.logoUi.menuHeight ? this.logoUi.menuHeight: '26px';
    },
  },
  watch: {
    '$route.path': {
      handler() {
        this.findMenu();
      },
      immediate: true,
    },
  },
  created() {
    this.initMenu = new PermissionsTranslation();
  },
  mounted() {
    mainBus.$on('fold-menu', () => {
      // eslint-disable-next-line no-unused-expressions
      !this.collapsed ? this.menuSwitchOnClick() : null;
    });
    mainBus.$on('expand-menu', () => {
      // eslint-disable-next-line no-unused-expressions
      this.collapsed ? this.menuSwitchOnClick() : null;
    });
    // 获取菜单权限
    post(api.baseMenuList, {
      tenantId: localStorage.getItem('tenantId'),
      appType: 1,
      accountId: localStorage.getItem('accountId'),
    }).then((res) => {
      if (res && res.length > 0) {
        this.menuList = this.initMenu.formattingMenu(res);
        this.menuList.forEach((item) => {
          if (item.children instanceof Array) {
            item.children.forEach((item3) => {
              // eslint-disable-next-line no-param-reassign
              item3.parentMenuCode = item.menuCode;
            });
          }
        });
        this.findMenu();
        localStorage.setItem('menuList', JSON.stringify(this.menuList));
        // 发送菜单列表加载完成事件
        mainBus.$emit('menu-list-loaded', this.menuList);
      } else {
        this.menuList = [];
        message.error('您暂无菜单权限，请联系管理员！');
        // 即使没有菜单权限，也发送事件通知其他组件
        mainBus.$emit('menu-list-loaded', []);
      }
    });
    // 获取按钮权限
    post(api.buttonPermissions, {
      tenantId: localStorage.getItem('tenantId'),
      appType: 1,
      accountId: localStorage.getItem('accountId'),
    }).then((res) => {
      if (res && res.length > 0) {
        localStorage.setItem('elements', JSON.stringify(res));
        mainBus.$emit('elements-exist', true);
      } else {
        // message.error('您暂无按钮权限，请联系管理员！');
      }
    });
    // eslint-disable-next-line eqeqeq
    // if (this.logoUi.appId && this.logoUi.appId == '10011') {
    //   // 根据产品需求，默认跳转客户管理页面
    //   setTimeout(() => {
    //     this.$router.push({
    //       path: '/crm/customerlist',
    //     });
    //   }, 1000);
    // }
    // TODO 如果缓存redirectUrl 存在 进程重定向
    let redirectUrl;
    // eslint-disable-next-line no-unused-expressions
    localStorage.getItem('redirectUrl')
      ? (redirectUrl = JSON.parse(localStorage.getItem('redirectUrl')))
      : (redirectUrl = null);
    if (localStorage.getItem('token')) {
      localStorage.removeItem('redirectUrl');
    }
    if (redirectUrl != null) {
      this.$router.push({
        path: redirectUrl.path,
        query: redirectUrl.params,
      });
    }
  },
  methods: {
    areIcon(k) {
      return !!k.includes('icon-');
    },
    toggleCollapsed(collapsed) {
      this.collapsed = collapsed;
    },
    findMenu() {
      const { path } = this.$route;
      let curMenu = {};
      const fn = (l) => {
        l.forEach((k) => {
          if (k.menuPath === path) {
            curMenu = k;
          } else if (k.children && k.children.length) {
            fn(k.children);
          }
        });
      };

      fn(this.menuList);
      if (curMenu && curMenu.menuCode) {
        this.selectedKey = [`${curMenu.menuCode}`];
        if (curMenu.parentMenuCode) {
          this.openKeys = [`${curMenu.parentMenuCode}`];
        } else {
          this.openKeys = [''];
        }
      } else {
        // this.openKeys = [''];
        this.selectedKey = [''];
      }
    },
    handleClick(e) {
      const { keyPath = [] } = e || {};
      if (keyPath && keyPath.length) {
        let list = this.menuList;
        let curMenu = {};
        keyPath.reverse().forEach((key) => {
          const obj = list.find((k) => k.menuCode === key);
          if (obj) {
            curMenu = obj;
            list = obj.children;
          }
        });
        if (curMenu.menuPath !== '-1') {
          if (curMenu.menuUrlType === 'ROUTE') {
            if (curMenu.menuPath.includes('znDatavista')) {
              this.openDatavista();
            } else if (
              curMenu.menuPath.includes('znWebUiXn')
              || curMenu.menuPath.includes('znAppUiXn')
            ) {
              // eslint-disable-next-line no-unused-expressions
              curMenu.menuPath.includes('znWebUi')
                ? window.open('https://webui-sit.linggekj.work/', '_blank')
                : window.open('https://appui-sit.linggekj.work/', '_blank');
            } else if (curMenu.menuPath.includes('znLowCodeAPPDocument')) {
              this.openZnLowCodeAPPDocument();
            } else {
              this.$router.push({
                path: curMenu.menuPath,
              });
            }
          }
          if (curMenu.menuUrlType === 'HTTTP') {
            window.open(curMenu.menuPath, '_blank');
          }
        }
      }
    },
    menuSwitchOnClick() {
      this.collapsed = !this.collapsed;
      this.$emit('onClick', this.collapsed);
      // eslint-disable-next-line no-undef
      mainBus.$emit('collapsed-click', this.collapsed);
    },
    openChange(keys) {
      if (keys.length > 0 && keys[keys.length - 1] !== '') {
        this.openKey = keys[keys.length - 1];
      }
      const codes = keys.filter((e) => !this.openKeys.some((m) => m === e));
      if (codes.length > 0) {
        this.toPoint(codes[0]);
      }
    },
    toPoint(code) {
      const k = this.menuList.filter((e) => e.code === code);
      let r;
      // eslint-disable-next-line no-unused-expressions
      k.length > 0 ? (r = pointMenus.filter((x) => x.id === k[0].id)) : (r = []);
      if (k.length > 0 && r.length > 0) {
        // pointTools.traceClick({
        //   event_type: 'web_click',
        //   content: {
        //     event_id: r[0].event_id || '',
        //     event_name: k[0].name || '',
        //   },
        // });
      }
    },
    openZnLowCodeAPPDocument() {
      /**
       * 打开外链=> apaas-app端文档
       */
      const token = localStorage.getItem('token');
      // 检查是否存在必要的参数
      if (!token) {
        // 处理缺少参数的异常情况
        message.error('文档缺少必要参数');
        return;
      }
      const lLinkURL = `https://apaas-demo.linggekj.com/hatch/#/home?token=${token}`;
      // 在新的浏览器选项卡或窗口中打开外链
      window.open(lLinkURL, '_blank');
    },
    openDatavista() {
      /**
       * 打开外链=>数据大屏中转页处理参数=>目标页面
       */
      const token = localStorage.getItem('token');
      const appId = localStorage.getItem('appId');

      // 检查是否存在必要的参数
      if (!token || !appId) {
        // 处理缺少参数的异常情况
        message.error('数据大屏缺少必要参数');
        return;
      }

      const externalLinkURL = `https://datavista.kaigongla.cn/lad?token=${token}&appId=${appId}`;
      // 在新的浏览器选项卡或窗口中打开外链
      window.open(externalLinkURL, '_blank');
    },
  },
};
</script>

<style lang="less" scoped>
.oms-menu {
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  user-select: none;

  .oms-menu-header {
    width: 100%;
    min-height: 60px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .logo {
      // width: 150px;
    }
  }

  .ant-menu-dark {
    background: #333333;
  }

  //::v-deep .ant-menu-submenu-title {
  //  text-align: center;
  //  padding: 0!important;
  //}
  //::v-deep .ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title{
  //  text-align: center;
  //  padding: 0!important;
  //}
  //::v-deep .ant-menu-item{
  //  text-align: center;
  //  padding: 0!important;
  //}
  .oms-menu-content {
    flex: 1;
    overflow-x: hidden;
    overflow-y: scroll;

    ::v-deep .ant-menu-dark .ant-menu-inline.ant-menu-sub {
      background: var(--navigationFoldColor);
      box-shadow: none;
      padding-left: 20px;
    }

    ::v-deep .ant-menu.ant-menu-dark .ant-menu-item-selected,
    .ant-menu.ant-menu-dark .ant-menu-item-active,
    .ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {
      background-color: var(--themeColor);
    }

    // ::v-deep .ant-menu-dark .ant-menu-item:hover {
    //   background: #52688f;
    // }

    ::v-deep .ant-menu-sub.ant-menu-inline > .ant-menu-item,
    ::v-deep .ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title,
    ::v-deep .ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
      height: 50px;
      line-height: 50px;
      border-bottom-left-radius: 30px;
      border-top-left-radius: 30px;

      .anticon + span {
        margin-left: 0 !important;
      }
    }

    ::v-deep .ant-menu-inline .ant-menu-item:not(:last-child) {
      margin-bottom: 0;
    }

    ::v-deep .ant-menu-inline .ant-menu-submenu-title,
    ::v-deep .ant-menu-inline .ant-menu-item {
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  ::v-deep  .ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {
    height: 50px;
    padding: 0 15px !important;
  }

  ::v-deep  .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
  .ant-menu-submenu-active,
  .ant-menu-submenu-title:hover {
    color: white;
  }

  .oms-menu-content {
    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.ant-menu-item:hover {
  background: var(--themeColor) !important;
}

.menu-switch {
  height: 33px;
  background-color: var(--navigationBackColor);
  display: flex;
  justify-content: flex-end;
  align-items: center;

  img {
    margin-right: 16px;
  }
}

.menuUnfold {
  justify-content: flex-end;

  img {
    margin-right: 16px;
  }
}

.menuFold {
  justify-content: center;

  img {
    margin-right: 0;
  }
}
</style>
<style lang="less" >
/* 菜单折叠后样式优化 Start */
.collapsedIconBg {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-top: 0;
}

.ant-menu-submenu.ant-menu-submenu-vertical .ant-menu-submenu-title {
  padding: 0 !important;
  text-align: center;
  width: 50px;
  height: 50px;
  line-height: 50px !important;
  margin: 0 auto;
  border-radius: 16px;
}

.ant-menu-submenu.ant-menu-submenu-vertical .ant-menu-submenu-title:hover {
  background: var(--themeColor);
}

.ant-menu-submenu.ant-menu-submenu-vertical.ant-menu-submenu-selected .ant-menu-submenu-title {
  background: var(--themeColor);
}

.ant-menu-submenu.ant-menu-submenu-vertical.ant-menu-submenu-open .ant-menu-submenu-title {
  background: var(--themeColor);
  color: #fff;
}
// 整体背景
.ant-menu-dark .ant-menu.ant-menu-vertical.ant-menu-sub {
  width: 232px;
  background: #3e5175;
  padding: 8px 0;
  border-radius: 8px;
}

// 缩小菜单背景
::v-deep .ant-menu-submenu-popup.ant-menu-dark .ant-menu-item {
  height: 50px;
  line-height: 50px;
  background-color: var(--themeColor) !important;
  margin: 0 !important;
  border-bottom-left-radius: 30px;
  border-top-left-radius: 30px;
}

.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {
  background: var(--themeColor);
}

.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-active {
  background: var(--themeColor);
}

.ant-menu-dark.ant-menu-submenu-popup {
  left: 84px !important;
}

/* 菜单折叠后样式优化 End */
</style>
